export function common() {
  const header = document.getElementById("js-header");

  // ヘッダーのスクロール処理
  const headerScroll = () => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 1 && window.innerWidth > 768) {
        header.classList.add("is-scroll");
      } else {
        header.classList.remove("is-scroll");
      }
    });
  };

  headerScroll();

  // ローディングアニメーションの初期化
  const initializeLoadingAnimation = () => {
    const isTopPage = location.pathname === "/" || location.pathname === "/index.html";
    if (!isTopPage) return; // トップページ以外では処理をスキップ

    const loadingMask = document.querySelector(".c-loading__mask");
    const loadingImg = document.querySelector(".c-loading__img");
    const loadingContainer = document.querySelector(".c-loading");

    if (loadingMask && loadingImg && loadingContainer) {
      // 初期状態を設定
      gsap.set(loadingMask, { opacity: 1, visibility: "visible" });
      gsap.set(loadingImg, { opacity: 0, visibility: "visible", scale: 0.98 });
      gsap.set(loadingContainer, { display: "block", visibility: "visible" });

      startLoadingAnimation(() => {
        // アニメーション終了時に完全に非表示
        gsap.set(loadingMask, { display: "none", visibility: "hidden" });
        gsap.set(loadingImg, { display: "none", visibility: "hidden" });
        gsap.set(loadingContainer, { display: "none", visibility: "hidden" });
      });
    } else if (loadingContainer) {
      // 要素が見つからない場合でも画面操作を可能にする
      loadingContainer.style.display = "none";
    }
  };

  // _accessリンクが押されたときの処理
  const accessLinks = document.querySelectorAll(".c-drawer__link._access");
  const drawerModal = document.querySelector(".c-drawer__modal");
  const drawerButton = document.querySelector(".js-drawerButton");

  accessLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      const href = link.getAttribute("href");
      const [url, hash] = href.split("#");
      const isCurrentPage = location.pathname === new URL(url, location.origin).pathname;
      const targetElement = hash ? document.getElementById(hash) : null;

      if (window.innerWidth <= 768) {
        handleSpNavigation(isCurrentPage, targetElement, drawerModal, drawerButton, url, hash);
      } else {
        handleNavigation(isCurrentPage, targetElement, drawerModal, drawerButton, url, hash);
      }
    });
  });

  // ページロード時にローディングアニメーションを初期化
  window.addEventListener("load", () => {
    initializeLoadingAnimation();

    const hash = window.location.hash;
    const targetId = hash ? hash.substring(1) : null;
    const targetElement = targetId ? document.getElementById(targetId) : null;

    if (targetElement) {
      // ローディング後に対象箇所へスクロール
      setTimeout(() => {
        targetElement.scrollIntoView({ behavior: "auto", block: "start" });
      }, 3300); // ローディング後
    }
  });
}

// SPサイズ専用の遷移処理
function handleSpNavigation(isCurrentPage, targetElement, drawerModal, drawerButton, url, hash) {
  closeDrawer(drawerModal, drawerButton);

  if (isCurrentPage && targetElement) {
    setTimeout(() => {
      targetElement.scrollIntoView({ behavior: "auto", block: "start" });
    }, 50);
  } else if (!isCurrentPage) {
    startLoadingAnimation(() => {
      window.location.href = `${url}#${hash}`;
    });
  }
}

// 通常の遷移処理
function handleNavigation(isCurrentPage, targetElement, drawerModal, drawerButton, url, hash) {
  closeDrawer(drawerModal, drawerButton);

  if (isCurrentPage && targetElement) {
    targetElement.scrollIntoView({ behavior: "auto", block: "start" });
  } else if (!isCurrentPage) {
    startLoadingAnimation(() => {
      window.location.href = `${url}#${hash}`;
    });
  }
}

// ドロワーを閉じる処理
function closeDrawer(drawerModal, drawerButton) {
  if (drawerModal && drawerButton) {
    drawerModal.classList.remove("is-open");
    drawerButton.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    document.body.style.touchAction = "";
  }
}

// ローディングアニメーション処理
function startLoadingAnimation(callback) {
  const loadingImg = document.querySelector(".c-loading__img");
  const loadingMask = document.querySelector(".c-loading__mask");

  if (loadingImg && loadingMask) {
    const openingTL = gsap.timeline();

    openingTL
      .to(loadingImg, {
        opacity: 1,
        scale: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.5,
      })
      .to(
        loadingImg,
        {
          opacity: 0,
          duration: 0.8,
          scale: 1.1,
          filter: "blur(5px)",
        },
        "+=1"
      )
      .to(
        loadingMask,
        {
          opacity: 0,
          duration: 0.5,
        },
        "-=0.5"
      )
      .eventCallback("onComplete", callback);
  } else {
    callback();
  }
}
